import React from "react";
import styled from "styled-components/macro";

import {
  Grid,
  Hidden,
  List,
  ListItemText as MuiListItemText,
  ListItem as MuiListItem,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Link from "@material-ui/core/Link";
import DevTools from "./dev/DevTools";
import DeveloperVisibilityFilter from "./DeveloperVisibilityFilter";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)}px;
  padding-right: ${(props) => props.theme.spacing(2)}px;
  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

const BrandLogoBackdrop = styled.span`
  display: inline-flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  padding: 4px 8px;
  margin-top: ${(props) => props.theme.spacing(3)}px;
  margin-right: ${(props) => props.theme.spacing(4)}px;
`;

const BrandLogo = styled.img`
  height: 28px;
  width: auto;
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden smDown>
          <Grid container item xs={12} md={7} justify="flex-end">
            <Grid container justify="flex-start">
              <Grid item>
                <Tooltip title="Built by Spheros Environmental">
                  <Link
                    href="https://spherosenvironmental.com"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <BrandLogoBackdrop>
                      <BrandLogo
                        src="/static/img/spheros-logo.png"
                        alt="Spheros Environmental"
                      />
                    </BrandLogoBackdrop>
                  </Link>
                </Tooltip>
              </Grid>
              <Grid item>
                <List>
                  <ListItem button={true} component="a" href="#">
                    <ListItemText primary="Documentation" />
                  </ListItem>
                  <ListItem button={true} component="a" href="#">
                    <ListItemText primary="Privacy" />
                  </ListItem>
                  <ListItem button={true} component="a" href="#">
                    <ListItemText primary="Terms of Service" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={5} justify="flex-end">
          <List>
            <ListItem>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - Spheros Environmental`}
              />
            </ListItem>
            <DeveloperVisibilityFilter>
              <ListItem button={true}>
                <DevTools />
              </ListItem>
            </DeveloperVisibilityFilter>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
